<div class="aside">
  <p class="title">Retiro</p>
  <button *ngFor="let denominacion of btnsRetiro$ | async" class="btn" (click)="postRetiro(denominacion.id)">${{denominacion.cantidad}}</button>
  <p class="title">Devolución</p>
  <button *ngFor="let denominacion of btnsDevolucion$ | async" class="btn" (click)="postDevolucion(denominacion.id)" >${{denominacion.cantidad}}</button>
</div>
